import React from "react";
import { HiOutlineMinus } from "react-icons/hi";

import code from "./assets/code.svg";
import digital from "./assets/digital-marketing.svg";
import man2 from "./assets/mthtanjim.jpg";
import design from "./assets/responsive-design.svg";
import seo from "./assets/seo.svg";

import "./styles/Section.scss";

const Section = () => {
  return (
    <div className="section" id="Section">
      <div className="section_skills__container">
        <div className="ProfSkillsHead">
          <h4>
            {" "}
            <HiOutlineMinus className="icon" />
            Professional
          </h4>
          <h1>Skills...</h1>
        </div>
        <div className="ProfessionalSkills">
          <img src={code} alt="" />
          <h2>API Development</h2>
          <p>Design and build robust, scalable RESTful APIs for seamless integration between software systems and platforms.</p>
        </div>

        <div className="ProfessionalSkills">
          <img src={design} alt="" />
          {/* <BsCodeSlash className="ProfessionalIcon" /> */}
          <h2>Frontend Developement</h2>
          <p>
          Specialised in building modern, responsive frontends with React.js and Next.js.
          </p>
        </div>
                <div className="ProfessionalSkills">
          <img src={code} alt="" />
          {/* <BsCodeSlash className="ProfessionalIcon" /> */}
          <h2>Custom Application Development</h2>
          <p>Develop bespoke web applications tailored to client needs, including CMS and CRM systems.</p>
        </div>
    
        <div className="ProfessionalSkills">
          <img src={digital} alt="" />
          <h2>Corporate Web Development</h2>
          <p>SEO-friendly, conversion-focused business websites designed to strengthen your online presence.</p>
        </div>

        <div className="ProfessionalSkills">
          <img src={seo} alt="" />
          <h2>Search Engine Optimization (SEO)</h2>
          <p>Comprehensive on-page SEO services tailored to all website types — from landing pages to large-scale platforms.</p>
        </div>
      </div>

      {/* after professional skills */}

      <div className="section__container">
        <div className="img_section_content">
          <div className="section__img">
            <img src={man2} alt="" />
          </div>
        </div>
        <div className="job_section_content">
          <h1>Employment History (5yr +)</h1>
          <div className="exp-box">
            <div className="exp-details">
              <h4>Software Engineer</h4>
              <h5> <span className="bold">ADVENTURE Dhaka Ltd</span></h5>
              <span> November 2024 to Running </span>
            </div>
       
            <div className="exp-details">
              <h4>Full Stack Developer</h4>
              <h5><span className="bold">NAVANA Group</span></h5>
              <span> April 2023 - October 2024 </span>
            </div>
            <div className="exp-details">
              <h4>Full Stack Developer</h4>
              <h5><span className="bold">DOM-INNO Group</span></h5>
              <span> August 2021 - April 2023 </span>
            </div>
            <br></br>
            <div className="exp-details">
              <h4>Web Application Developer</h4>
              <h5>
                 <span className="bold">DEMO Group</span>  <br /> 
              </h5>
              <span>
                {" "}
                January 2020 - July 2021{" "}
              </span>
            </div>
           
          </div>
        </div>
        {/* <div className="section__content">
          <div>
            <h1>Educations</h1>
            <div className="exp-details">
              <h4>B.Sc. in Computer Science & Engineering (CSE) </h4>
              <h5>South East University</h5>
              <span>(2019 - 2022)</span>
            </div>
            <div className="exp-details">
              <h4>Diploma in Engineering in Computer Technology (4 years) </h4>
              <h5>Bhola Govt. Polytechnic institute</h5>
              <span>(2013 - 2017)</span>
            </div>
            <div className="exp-details">
              <h4>S.S.C, Science Group;</h4>
              <h5>Kishorpur N U A High School (2013)</h5>
              <span>Passing Yers: 2013</span>
            </div>
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default Section;
